$(document).ready(function() {
    (function initAccoTrackingAndScrollto() {
        $('a[data-scrollto]').click(function(e) {
            var offset = $(e.target).data('scrollto') || -100;
            var hash = e.target.hash;
            $.scrollTo(hash, 1000, { offset: offset }); // 300px scrollspy - 54px Header
            return false;
        });
    })();

    // Load Gallery
    const el = document.querySelector('[slider="acco-gallery"]');
    if (el) {
        // swiper
        var swiper = new Swiper(el,
            {
                loop: true,
                autoplay: { delay: 7000 },
                navigation: {
                    prevEl: el.querySelector(".slider-button-prev"),
                    nextEl: el.querySelector(".slider-button-next")
                }
            });

        // thumbnails sync
        const thumbnails = $('#accomediastrip #thumbnails a');
        swiper.on('activeIndexChange',
            function() {
                $(thumbnails).removeClass('active');
                $(thumbnails).filter(`[data-id=${this.realIndex}]`).addClass('active');
            });
        thumbnails.on('click', function(e) {
            e.stopPropagation();
            const id = $(this).data("id");
            swiper.slideTo(id + 1);
            $(thumbnails).removeClass('active');
            $(this).addClass('active');
            return false;
        });

        // thumbnails expand
        const elThumbnails = document.querySelector('#accomediastrip #thumbnails');
        const elExpander = document.querySelector('#accomediastrip #thumbnails .expander');
        const elButton = elExpander.querySelector('button');
        if (elThumbnails && elExpander && elButton) {
            elButton.addEventListener("click",
                function () {
                    elButton.style.display = "none";
                    elThumbnails.classList.remove('shrinked');
                });
        }
    }

    // Init Scollspy
    $('body').scrollspy({
        offset: 150,
        target: "#accobar-menu"
    });

});

function LoadPackageWidget(supercompanyId, lang, langStringForRangeDatepick, gapushlabel) {
    SuedtirolcomPackagesWidget.showWidget({
            languageid: lang,
            supercompanyid: supercompanyId,
            height: "900",
            width: $('#packages').width(),
            scroll: false,
            datepickerdisabled: "true",
            //minpriceperday: 95,
            colors: {
                innerbackgroundcolor: "#fff",
                innertextcolor: "#333333",
                linkcolor: "#003B8B",
                outerbackgroundcolor: "#C9AB33",
                outertextcolor: "#ffffff",
                titlecolor: "#333333"
            },
            externalLinkCallbackfunction: "window.siteEvent('company_clicks', 'enquiry_package', '" + gapushlabel + "');ScrollToPackageForm({0},' + gapushlabel + ');return false;",
            externalbooklinkcallbackfunction: 'window.siteEvent("company", "package", "' + gapushlabel + '");window.open($(this).data("url"));',
        buttonCssClass: 'btn btn-gswarning',
        disablebuttoncss: true,
        key: '54640adsfiH'
    }, function() {
        // Binde Datepicker
        $('#FromDate').RangeDatepick({
            inputFrom: '#FromDate',
                inputTo: '#ToDate',
                maxMonthsToShow: 2,
                lang: langStringForRangeDatepick
            });

            ScrollToHash();

            //$('body').scrollspy({
            //    offset: 150,
            //    target: "#accobar-menu"
            //});
        });
}

function ScrollToPackageForm(packageId, gapushlabel) {
    DisableClick($('a[href^="#enquiry"]').parent());
    $('a[href^="#enquiry"]').click();
    EnableClick($('a[href^="#enquiry"]').parent());
    $.scrollTo($('#enquiry'), 1000, { offset: -180 });

    $('#spezialenquirycont').css("min-height", "100px");
    $('#spezialenquirycont').html("<img src='/img/ajax-loader.gif' style='margin-top:30px;' title='loading'>");

    var language = gardaseeContext.language;

    $.ajax({
        cache: false,
        url: '/ajax/package',
        type: "POST",
        data: { packageid: packageId, language: language },
        traditional: true,
        success: function(data) {
            $('#spezialenquirycont').html(data);
            SetImpression(this, gapushlabel);
        }
    });
}

function ScrollToRoomcategoryForm(roomcategoryId, gapushlabel) {
    DisableClick($('a[href^="#enquiry"]').parent());
    $('a[href^="#enquiry"]').click();
    EnableClick($('a[href^="#enquiry"]').parent());
    $.scrollTo($('#enquiry'), 1000, { offset: -180 });

    var language = gardaseeContext.language;

    $.ajax({
        cache: false,
        url: '/ajax/roomcategory',
        type: "POST",
        data: { roomcategoryId: roomcategoryId, language: language },
        traditional: true,
        success: function(data) {
            $('#spezialenquirycont').html(data);
            SetImpression(this, gapushlabel);
        }
    });

    $('#spezialenquirycont').css("min-height", "100px");
    $('#spezialenquirycont').html("<img src='/img/ajax-loader.gif' style='margin-top:30px;' title='loading'>");
}

function DisableClick(that) {
    var $this = $(that);
    var click = $this.attr('onclick');
    if (click) {
        $this.data('click', click);
        // add return false to prevent default action
        $this[0].onclick = function() { return false; };
    }
}

function EnableClick(that) {
    var $this = $(that);
    $this.removeClass('disabled');
    var click = $this.data('click');
    if (click) {
        $this[0].onclick = click;
    }
}

function SetImpression(element, gapushlabel) {
    if (gapushlabel != undefined && gapushlabel != '') {
        if (element != undefined) {
            window.siteEvent('company_impression', $(element).attr("href").replace("#", ""), gapushlabel);
        } else {
            $('#myTab .active a').each(function() {
                window.siteEvent('company_impression', $(this).attr("href").replace("#", ""), gapushlabel);
            });
        }
    }
}
